import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createNewTabInWorkstream as mutation } from "../modules/CustomDashboardModule/services/DashboardConfigurationService";

/**
 * Creates a callable method to pass in a on click
 * @param {Object} props - The module's config so this hook knows what to update and read
 * @param {Object} props.selectors - an object containing redux selectors for `tabs` and `id`
 * @param {function} props.selectors.id - redux selector for id
 * @param {function} props.selectors.tabs - redux selector for tabs
 * @param {function} props.onResonse - action to add in a tab to the slice
 * @param {function} props.onLoading - loading state handler
 * @param {function} props.onError - error state handler
 * @returns {Object} That contains a function to be called in an `onClick` event
 */
export const useAddDashboardTabMutation = ({
  selectors: { tabs: tabsSelector, id: idSelector },
  onResponse,
  onLoading,
  onError,
}) => {
  const dispatch = useDispatch();
  const dashboardId = useSelector(idSelector);
  const tabs = useSelector(tabsSelector);

  const addWorkStreamTab = useCallback(async () => {
    try {
      const count = tabs.length ? tabs.length + 1 : 0;

      const name = `New Tab ${count.toString().padStart(2, "0")}`;
      const body = {
        name,
        dashboardId,
        order: count,
        accountId: localStorage.getItem("u_account_id"),
      };

      dispatch(onLoading(true));
      const newTab = await mutation(body);
      dispatch(onResponse(newTab));
    } catch (error) {
      dispatch(onError(error));
    } finally {
      dispatch(onLoading(false));
    }
  }, [tabs.length, dashboardId]);

  return { addWorkStreamTab };
};
